var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100 no-mobile"},[_c('img',{staticClass:"no-mobile-gif",attrs:{"src":require("@/assets/images/pages/no_portrait_mode.gif")}}),_c('div',{staticClass:"no-mobile-text"},[_vm._v("Mobile view is not supported")])])
}]

export { render, staticRenderFns }